const indexItems = [
  { letter: 'A', title: '动作冒险', count: '3,821部', desc: '肾上腺素飙升的视听盛宴' },
  { letter: 'B', title: '悬疑惊悚', count: '2,456部', desc: '层层反转烧脑佳作' },
  { letter: 'C', title: '科幻奇幻', count: '1,987部', desc: '探索无限想象边界' },
  { letter: 'D', title: '喜剧爱情', count: '4,102部', desc: '轻松笑料温暖治愈' },
  { letter: 'E', title: '古装历史', count: '2,318部', desc: '穿越时空感受传奇' },
  { letter: 'F', title: '动画动漫', count: '3,645部', desc: '全年龄段的视觉魔法' },
  { letter: 'G', title: '纪录纪实', count: '1,203部', desc: '真实世界的精彩叙事' },
];

export default function SectionIndex() {
  return (
    <section id="index" className="bg-background-50 py-16 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap mb-3">
            分类导航
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            影视类型索引
          </h2>
          <p className="text-foreground-600 text-sm mt-2">按类型快速浏览片库，总有一个分类击中你的喜好</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-lg p-5 border border-background-200/70 group cursor-pointer hover:border-primary-200 transition-colors flex items-start gap-4"
            >
              <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 group-hover:bg-primary-200 transition-colors">
                <span className="font-heading text-xl font-bold text-primary-600">{item.letter}</span>
              </div>
              <div className="min-w-0">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
                <p className="text-xs text-foreground-400 mt-1">{item.count}</p>
              </div>
              <div className="flex-shrink-0 self-center ml-auto opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-arrow-right-s-line text-primary-500"></i>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-6">
          <p className="text-foreground-400 text-xs">
            覆盖共 7 大主题分类，19,532 部影片持续更新中
          </p>
        </div>
      </div>
    </section>
  );
}